/* ==========================================================================
   Ryse - Theoric: carrossel de recomendados na gaveta do carrinho.
   Indicador (20/07/2026): bolinha -> tracinho no ativo (CSS). Fonte UNICA da
   verdade = a posicao real da rolagem: o ponto ativo e sempre o card a mostra,
   e irPara() SO rola (quem move o indicador e o evento de scroll). Sem isso, o
   indicador e o carrossel dessincronizavam (um andava sem o outro).
   ========================================================================== */
(function () {
  'use strict';

  var T = window.TheoricCart;
  if (!T) {
    console.error('[theoric-cart-recs] theoric-cart-core.js nao carregou.');
    return;
  }

  var LIMITE = 8;
  var SECAO = 'theoric-cart-recs';
  var TEMPO_CONFIRMACAO = 1400;
  var INTERVALO_AUTOPLAY = 3800;

  var buscando = false;
  var cacheHtml = null;
  var cacheChave = null;

  var semMovimento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function gaveta() { return document.querySelector('cart-theoric'); }
  function destino() { return document.querySelector('.theoric__content-scroll'); }
  function jaEstaNaTela() {
    var d = destino();
    return !!(d && d.querySelector('[data-theoric-cart-recs]'));
  }

  function invalidarCache() { cacheHtml = null; cacheChave = null; }

  function assinatura(carrinho) {
    return (carrinho.items || []).map(function (i) { return i.product_id; }).sort().join('-');
  }

  function temProduto(html) { return !!html && html.indexOf('theoric-cart-recs__card') !== -1; }

  function buscarHtml(produtoId) {
    var base = '/recommendations/products?section_id=' + SECAO + '&product_id=' + produtoId + '&limit=' + LIMITE;
    return fetch(base + '&intent=complementary')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        if (temProduto(html)) return html;
        return fetch(base + '&intent=related').then(function (r) { return r.text(); });
      });
  }

  function quizPorUltimo(alvo) {
    var convite = alvo.querySelector(':scope > .empty-state');
    var botao = alvo.querySelector(':scope > a.Inner_cart');
    if (convite) alvo.appendChild(convite);
    if (botao) alvo.appendChild(botao);
  }

  function montarCarrossel(bloco) {
    var trilho = bloco.querySelector('[data-recs-track]');
    var pontos = bloco.querySelector('[data-recs-dots]');
    if (!trilho) return;

    var cards = trilho.querySelectorAll('.theoric-cart-recs__card');
    if (cards.length < 2) return;

    var atual = 0;
    var timer = null;
    var desligado = false;

    var listaPontos = [];
    if (pontos) {
      pontos.innerHTML = '';
      for (var i = 0; i < cards.length; i++) {
        (function (indice) {
          var p = document.createElement('button');
          p.type = 'button';
          p.className = 'theoric-cart-recs__dot';
          p.setAttribute('role', 'tab');
          p.setAttribute('aria-label', 'Ver recomendado ' + (indice + 1) + ' de ' + cards.length);
          p.addEventListener('click', function () { desligar(); irPara(indice); });
          pontos.appendChild(p);
          listaPontos.push(p);
        })(i);
      }
    }

    function marcarPonto(indice) {
      atual = indice;
      for (var i = 0; i < listaPontos.length; i++) {
        var ativo = i === indice;
        listaPontos[i].classList.toggle('is-active', ativo);
        listaPontos[i].setAttribute('aria-selected', String(ativo));
      }
    }

    /* indice = card mais proximo da borda ESQUERDA do trilho; no fim da rolagem
       forca o ultimo. Reflete a posicao REAL do scroll (fonte unica). */
    function indiceAtual() {
      var max = trilho.scrollWidth - trilho.clientWidth;
      if (max <= 2) return 0;
      if (trilho.scrollLeft >= max - 2) return cards.length - 1;
      var ref = trilho.getBoundingClientRect().left + 1;
      var best = 0, dist = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var d = Math.abs(cards[i].getBoundingClientRect().left - ref);
        if (d < dist) { dist = d; best = i; }
      }
      return best;
    }

    /* SO rola o card i ate a esquerda; o indicador e atualizado pelo scroll. */
    function irPara(indice) {
      var alvo = cards[indice].getBoundingClientRect().left - trilho.getBoundingClientRect().left;
      trilho.scrollBy({ left: alvo, behavior: semMovimento ? 'auto' : 'smooth' });
    }
    function proximo() { irPara((indiceAtual() + 1) % cards.length); }

    var ticking = false;
    trilho.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { marcarPonto(indiceAtual()); ticking = false; });
    }, { passive: true });
    window.addEventListener('resize', function () { marcarPonto(indiceAtual()); });

    function ligar() {
      if (desligado || semMovimento || timer) return;
      timer = setInterval(function () {
        if (document.hidden) return;
        var g = gaveta();
        if (g && !g.classList.contains('active')) return;
        proximo();
      }, INTERVALO_AUTOPLAY);
    }
    function pausar() { clearInterval(timer); timer = null; }
    function desligar() { desligado = true; pausar(); }

    bloco.addEventListener('mouseenter', pausar);
    bloco.addEventListener('mouseleave', ligar);
    bloco.addEventListener('focusin', pausar);
    trilho.addEventListener('pointerdown', desligar);
    trilho.addEventListener('touchstart', desligar, { passive: true });
    trilho.addEventListener('wheel', desligar, { passive: true });
    trilho.addEventListener('keydown', desligar);

    marcarPonto(indiceAtual());
    ligar();
  }

  function colocar(html) {
    var alvo = destino();
    if (!alvo) return;
    if (alvo.querySelector('[data-theoric-cart-recs]')) return;

    var temp = document.createElement('div');
    temp.innerHTML = html;
    var bloco = temp.querySelector('[data-theoric-cart-recs]');
    if (!bloco) return;

    alvo.appendChild(bloco);
    quizPorUltimo(alvo);
    ligarBotoes(bloco);
    montarCarrossel(bloco);
  }

  function pintar(carrinho) {
    if (!carrinho || !destino()) return;
    if (!carrinho.items || !carrinho.items.length) { invalidarCache(); return; }

    var chave = assinatura(carrinho);
    if (chave === cacheChave && jaEstaNaTela()) return;
    if (chave === cacheChave && cacheHtml) { colocar(cacheHtml); return; }

    if (buscando) return;
    buscando = true;

    var ultimo = carrinho.items[carrinho.items.length - 1];

    buscarHtml(ultimo.product_id)
      .then(function (html) {
        cacheChave = chave;
        if (!temProduto(html)) { cacheHtml = null; return; }
        cacheHtml = html;
        colocar(html);
      })
      .catch(function (erro) {
        console.warn('[theoric-cart-recs] falha ao montar os recomendados. A gaveta segue normal.', erro);
      })
      .finally(function () { buscando = false; });
  }

  function ligarBotoes(escopo) {
    var botoes = escopo.querySelectorAll('[data-theoric-rec-add]');
    Array.prototype.forEach.call(botoes, function (botao) {
      botao.addEventListener('click', function () {
        var variante = botao.getAttribute('data-variant-id');
        if (!variante || botao.disabled) return;
        botao.disabled = true;

        var carrinho = gaveta();
        var dados = new FormData();
        dados.append('id', variante);
        dados.append('quantity', 1);

        if (carrinho && typeof carrinho.getSectionsToRender === 'function') {
          dados.append('sections', carrinho.getSectionsToRender().map(function (s) { return s.id; }));
          dados.append('sections_url', window.location.pathname);
        }

        fetch('/cart/add.js', { method: 'POST', body: dados })
          .then(function (r) { return r.json(); })
          .then(function (resposta) {
            if (resposta.status && resposta.description) { throw new Error(resposta.description); }
            botao.classList.add('is-added');
            var rotulo = botao.querySelector('span');
            if (rotulo) rotulo.textContent = 'Adicionado';
            invalidarCache();
            setTimeout(function () {
              if (carrinho && typeof carrinho.renderContents === 'function') { carrinho.renderContents(resposta); }
              T.sincronizar(true);
            }, TEMPO_CONFIRMACAO);
          })
          .catch(function (erro) {
            console.error('[theoric-cart-recs] nao foi possivel adicionar.', erro);
            botao.disabled = false;
          });
      });
    });
  }

  T.ao(pintar);
})();